export { PurchaseResume } from '@src/features/orders/legacy/PurchaseResume';
export { default as SaleDisplay } from '@src/features/orders/legacy/SaleDisplay';
export { default as SaleConfirmation } from '@src/features/orders/legacy/SaleConfirmation';
export { SuccessfulPayment } from '@src/features/orders/legacy/SuccessfulPayment';
